
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scout/datasets/[dataset]",
      function () {
        return require("private-next-pages/scout/datasets/[dataset]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scout/datasets/[dataset]"])
      });
    }
  